module.exports = __webpack_public_path__ + "img/H-63-ST-1000-BB.0fda3e6e.png";